import { Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import { LoadComponent } from '@yooink/youtils/es/LoadComponent';

const List = LoadComponent(() => import('./List'));
const Edit = LoadComponent(() => import('./Edit'));


const SuperUsersRoute = props => (
	<Fragment>
		<Route exact path="/system/users" component={List} />
		<Switch>
			<Route exact path="/system/users/:id" component={Edit} />
		</Switch>
	</Fragment>
	);

export { SuperUsersRoute };
